const images = [
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/6210006094bf0505319691495bb7c747.jpeg',
    alt: 'Trang phục truyền thống Bahnar',
  },
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/9d8d95fc79b8498b0ee4a04feb5db31e.jpeg',
    alt: 'Lễ hội cồng chiêng',
  },
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/91d78c64537f5fc34807823a69a49238.jpeg',
    alt: 'Nhà rông Bahnar',
  },
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/51f2913477b8c2be6ef69f47e2f83698.jpeg',
    alt: 'Dệt thổ cẩm',
  },
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/ee4b796fff1b8dee191a48589ebc0f99.jpeg',
    alt: 'Trẻ em vui chơi',
  },
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/9d8d95fc79b8498b0ee4a04feb5db31e.jpeg',
    alt: 'Ẩm thực dân gian',
  },
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/d6d6c04fcd9086d70fa94b137e3eb74b.jpeg',
    alt: 'Sinh hoạt cộng đồng',
  },
  {
    src: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/c8b57286471f0cb585eee52bcbf6c7f0.jpeg',
    alt: 'Nhạc cụ dân tộc',
  },
];

// Duplicate for seamless loop
const allImages = [...images, ...images];

export default function CultureSlider() {
  return (
    <section className="py-20 overflow-hidden" style={{ background: 'linear-gradient(135deg, #fdf6ec 0%, #fff8f0 50%, #fdf0e4 100%)' }}>
      <div className="max-w-7xl mx-auto px-6 mb-12 text-center">
        <div className="inline-flex items-center gap-2 bg-primary-orange/10 text-primary-orange px-4 py-1.5 rounded-full text-base font-semibold mb-4">
          <i className="ri-compass-3-fill"></i>
          Khám phá văn hóa
        </div>
        <h2 className="text-5xl font-bold text-primary-brown-dark mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
          Nét đẹp văn hóa Bahnar
        </h2>
        <p className="text-xl text-primary-brown-light max-w-xl mx-auto leading-relaxed">
          Những hình ảnh đặc trưng về văn hóa và sinh hoạt đời thường của người dân Bahnar.
        </p>
      </div>

      {/* Row 1 — lướt trái */}
      <div className="relative mb-5" style={{ maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)' }}>
        <div className="flex gap-5 marquee-left" style={{ width: 'max-content' }}>
          {allImages.map((img, idx) => (
            <div
              key={`row1-${idx}`}
              className="flex-shrink-0 rounded-2xl overflow-hidden"
              style={{ width: '340px', height: '220px' }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Row 2 — lướt phải (ngược chiều) */}
      <div className="relative" style={{ maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)' }}>
        <div className="flex gap-5 marquee-right" style={{ width: 'max-content' }}>
          {[...allImages].reverse().map((img, idx) => (
            <div
              key={`row2-${idx}`}
              className="flex-shrink-0 rounded-2xl overflow-hidden"
              style={{ width: '340px', height: '220px' }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee-left {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-right {
          0%   { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .marquee-left {
          animation: marquee-left 30s linear infinite;
        }
        .marquee-right {
          animation: marquee-right 30s linear infinite;
        }
        .marquee-left:hover,
        .marquee-right:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
